import { Injectable } from '@angular/core';
import { enumEnvironmentName } from '@env/enumEnvironmentName';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class GtmService {
  private readonly scriptId = 'gtm-script';
  private readonly noscriptId = 'gtm-noscript';

  initGtm(): void {
    const acceptedEnvironments = [enumEnvironmentName.TEST, enumEnvironmentName.STAGE, enumEnvironmentName.PROD];

    if (!acceptedEnvironments.includes(environment.name)) {
      return;
    }

    const gtmId = environment.gtmId;
    if (!gtmId || document.getElementById(this.scriptId)) return;

    // Initialize dataLayer
    window['dataLayer'] = window['dataLayer'] || [];

    // Create and inject the GTM script
    const script = document.createElement('script');
    script.id = this.scriptId;
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;

    // Insert the script into head
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(script, firstScriptTag);

    // Create and inject the noscript iframe
    const noscript = document.createElement('noscript');
    noscript.id = this.noscriptId;

    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';

    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  }
}
